var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PaymentClientError, PaymentErrorShortCodes, PaymentTimeoutError } from '../../index.js';
import { Config } from '../../Configs/index.js';
import { PaymentVendors } from '../../Interfaces/interface.adapter.js';
import { PaymentAdapterIngenico } from '../../Adapters/index.js';
import RSAKey from './vendor/rsa.js';
import { hex2b64 } from './vendor/base64.js';
var PaymentLegacyEncryptor = /** @class */ (function () {
    function PaymentLegacyEncryptor() {
        // Empty constructor
    }
    PaymentLegacyEncryptor.prototype.ingenicoEncryptCreditCardInfo = function (env, encodedSession, creditCard, billingContact) {
        return __awaiter(this, void 0, void 0, function () {
            var sessionInfo, ingenicoAdapter, encryptedCard, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sessionInfo = {
                            sessionId: '',
                            vendorName: PaymentVendors.ingenico,
                            vendorSessionPayload: encodedSession,
                            billingToken: '',
                            timestamp: ''
                        };
                        ingenicoAdapter = new PaymentAdapterIngenico(env, sessionInfo, billingContact);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                // eslint-disable-next-line prefer-const
                                var timeoutId;
                                ingenicoAdapter
                                    .encryptCreditCardData(creditCard)
                                    .then(function (encryptedCardData) {
                                    clearTimeout(timeoutId);
                                    resolve(encryptedCardData);
                                })
                                    .catch(function (e) {
                                    clearTimeout(timeoutId);
                                    reject(e);
                                });
                                timeoutId = setTimeout(function () {
                                    reject('timeout');
                                }, Config.defaultVendorTimeout);
                            })];
                    case 2:
                        encryptedCard = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        if (e_1 instanceof PaymentClientError) {
                            throw e_1;
                        }
                        throw new PaymentTimeoutError('Payment time-out while waiting for vendor response');
                    case 4: return [2 /*return*/, encryptedCard];
                }
            });
        });
    };
    PaymentLegacyEncryptor.prototype.rsaEncryptCreditCardInfo = function (encryptionKey, creditCard, ignoreCVV) {
        return __awaiter(this, void 0, void 0, function () {
            var stringToEncrypt, encryptedResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        stringToEncrypt = ignoreCVV ? "cc_no=".concat(creditCard.number) : "cc_no=".concat(creditCard.number, "&cvv=").concat(creditCard.securityCode);
                        return [4 /*yield*/, this.rsaEncryptPanData(encryptionKey, stringToEncrypt)];
                    case 1:
                        encryptedResult = _a.sent();
                        return [2 /*return*/, encryptedResult];
                }
            });
        });
    };
    PaymentLegacyEncryptor.prototype.rsaEncryptACHInfo = function (encryptionKey, achInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var encryptedResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.rsaEncryptPanData(encryptionKey, "bank_acct_no=".concat(achInfo.bankAccountNumber, "&bank_routing_no=").concat(achInfo.bankRoutingNumber))];
                    case 1:
                        encryptedResult = _a.sent();
                        return [2 /*return*/, encryptedResult];
                }
            });
        });
    };
    PaymentLegacyEncryptor.prototype.rsaEncryptECheckInfo = function (encryptionKey, eCheckInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var driversLicenseData, encryptedResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        driversLicenseData = eCheckInfo.driverLicenseIssuingState + '' + eCheckInfo.driverLicenseNumber;
                        return [4 /*yield*/, this.rsaEncryptPanData(encryptionKey, "bank_acct_no=".concat(eCheckInfo.bankAccountNumber, "&bank_routing_no=").concat(eCheckInfo.bankRoutingNumber, "&check_no=").concat(eCheckInfo.checkNumber, "&driver_license_no=").concat(driversLicenseData))];
                    case 1:
                        encryptedResult = _a.sent();
                        return [2 /*return*/, encryptedResult];
                }
            });
        });
    };
    PaymentLegacyEncryptor.prototype.rsaEncryptEPaperTokenInfo = function (encryptionKey, ePaperTokenInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var encryptedResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.rsaEncryptPanData(encryptionKey, "cc_no=".concat(ePaperTokenInfo.ePaperToken))];
                    case 1:
                        encryptedResult = _a.sent();
                        return [2 /*return*/, encryptedResult];
                }
            });
        });
    };
    PaymentLegacyEncryptor.prototype.rsaEncryptPanData = function (encryptionKey, panData) {
        return __awaiter(this, void 0, void 0, function () {
            var rsa, encryptedResult, encryptedPanData;
            return __generator(this, function (_a) {
                try {
                    rsa = new RSAKey();
                    rsa.setPublic(encryptionKey, '10001');
                    encryptedResult = rsa.encrypt(panData);
                    encryptedPanData = encryptedResult ? hex2b64(encryptedResult) : null;
                    if (!encryptedPanData) {
                        throw new PaymentClientError('Failed to encrypt payment data, please check the encryption key.', PaymentErrorShortCodes.invalid_card_number_encryption_error);
                    }
                    return [2 /*return*/, encryptedPanData];
                }
                catch (e) {
                    throw new PaymentClientError('Failed to encrypt payment data, please check the encryption key.', PaymentErrorShortCodes.invalid_card_number_encryption_error, {
                        cause: {
                            message: e.message,
                            details: JSON.stringify(e)
                        },
                        code: 'BG-1065'
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    return PaymentLegacyEncryptor;
}());
export { PaymentLegacyEncryptor };
